import { render, staticRenderFns } from "./who-you-are.vue?vue&type=template&id=69d5c644&"
import script from "./who-you-are.vue?vue&type=script&lang=js&"
export * from "./who-you-are.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports